export enum PermitteeType {
  originalSubmitter =  0,
  allApprovers =       1,
  group =              2,
  user =               3,
  thirdParty =         4,
  allCompleters =      5,
  stepCompleters =     6,
  email =              7,
  entityOwner =        8,
  objectOwner =        9,
  relatedObjectOwner = 10,
  priorStep =          11,
  lookupField =        12,
  anyone =             13,
  accountRelation =    14,
  entityAccountRelation = 15,
  anyoneInApp =        16,
}

export const PriorStepTypes = [
  PermitteeType.originalSubmitter,
  PermitteeType.group,
  PermitteeType.user,
  PermitteeType.priorStep,
  PermitteeType.thirdParty,
  PermitteeType.lookupField,
]